export const BACKEND_URL = 'https://server-2discreet.herokuapp.com/api'